var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.size == 'normal')?_c('div',{staticClass:"loading-circle",class:_vm.classes},[_vm._m(0)]):(_vm.size == 'small')?_c('div',{staticClass:"spinner spinner--1"}):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])
}]

export { render, staticRenderFns }